// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getCopyrightLicenseById } from 'app/constants/enums/CopyrightLicense/main';

/* eslint-disable max-len */
export const ALL_RIGHTS_RESERVED = getCopyrightLicenseById('allRightsReserved');
export const CREATIVE_COMMONS_BY = getCopyrightLicenseById('creativeCommonsBy');
export const CREATIVE_COMMONS_BY_SA = getCopyrightLicenseById('creativeCommonsBySa');
export const PUBLIC_DOMAIN = getCopyrightLicenseById('publicDomain');
/* eslint-enable max-len */
